/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Statuses_PendingInputs */

const es_feedback_statuses_pending = /** @type {(inputs: Feedback_Statuses_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente`)
};

const en_feedback_statuses_pending = /** @type {(inputs: Feedback_Statuses_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Feedback_Statuses_PendingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_statuses_pending = /** @type {((inputs?: Feedback_Statuses_PendingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Statuses_PendingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_statuses_pending(inputs)
	return en_feedback_statuses_pending(inputs)
});
export { feedback_statuses_pending as "feedback.statuses.pending" }